import type { ReactNode } from "react";

/**
 * Passthrough wrapper for Home, Member cost share, Referrals and the referral detail.
 *
 * These sections stay reachable for every org, including an incomplete pharmacy:
 * the server authorizes the cost-tool and enrollments-list reads on membership
 * alone (a pending org gets empty results, not a 403), and gates referral
 * minting on `can_take_referrals` server-side, so an unlocked tab never lets a
 * pending org create a referral. This wrapper stays as the routes' named
 * boundary and renders its children unguarded.
 */
export function RequireOrgComplete({ children }: { children: ReactNode }): ReactNode {
  return <>{children}</>;
}
